import { createSlice } from "@reduxjs/toolkit";

const subFormSlice = createSlice({
    name: 'subForm',
    initialState: {
        isLoading: false,
        formsubmodules: [],
        tableColumns: {},
        variants: [],
        totalCount: 0,
        modules: [],
        moduleLogs: [],
        workflowRules : false,
        sapStatus : false,
        exit : false,
        reload : false,
        message: null,
        moduleMessage: null,
        status : false,
        error: null
    },
    reducers: {
        createSubFormStart: (state) => {
            state.isLoading = true;
        },
        createSubFormSuccess: (state, action) => {
            state.formsubmodules = action?.payload?.formsubmodules;
            state.message = action?.payload?.message;
            state.exit = true;
            state.isLoading = false;
            state.status = action?.payload?.status;
            state.reload = false;
        },
        createSubFormFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getSubFormListStart: (state) => {
            state.isLoading = true;
        },
        getSubFormListSuccess: (state, action) => {
            state.variants = action?.payload?.variants;
            state.tableColumns = action?.payload?.tableColumns;
            state.formsubmodules = action?.payload?.formsubmodules;
            state.totalCount = action?.payload?.totalCount;
            state.modules = action?.payload?.modules;
            state.lookupData= action?.payload?.lookup_data;
            state.workflowRules= action?.payload?.workflow_rules;
            state.sapStatus= action?.payload?.sap_status;
            state.message = action?.payload?.message;
            state.isLoading = false;
            state.status = action?.payload?.status;
            state.reload = false;
            state.exit = false;
        },
        getSubFormListFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getSubFormListByIdStart: (state) => {
            state.isLoading = true;
        },
        getSubFormListByIdSuccess: (state, action) => {
            state.formsubmodules = action?.payload?.formsubmodules;
            state.modules = action?.payload?.modules;
            state.message = action?.payload?.message;
            state.isLoading = false;
            state.status = action?.payload?.status;
            state.reload = false;
            state.exit = false;
        },
        getSubFormListByIdFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        updateSubFormByIdStart: (state, action) => {
            state.isLoading = true;
        },
        updateSubFormByIdSuccess: (state, action) => {
            state.formsubmodules = action?.payload?.formsubmodules;
            state.message = action?.payload?.message;
            state.exit = true;
            state.isLoading = false;
            state.status = action?.payload?.status;
            state.reload = false;
        },
        updateSubFormByIdFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        removeSubFormByIdStart: (state, action) => {
            state.isLoading = true;
        },
        removeSubFormByIdSuccess: (state, action) => {
            state.reload = true;
            state.isLoading = false;
            state.status = action?.payload?.status;
        },
        removeSubFormByIdFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        bulkUploadSubFormByIdStart: (state, action) => {
            state.isLoading = true;
        },
        bulkUploadSubFormByIdSuccess: (state, action) => {
            state.reload = true;
            state.isLoading = false;
            state.status = action?.payload?.status;
        },
        bulkUploadSubFormByIdFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createTableColumnSubFormModuleStart: (state) => {
            state.isLoading = true;
        },
        createTableColumnSubFormModuleSuccess: (state, action) => {
            state.tableColumns = action?.payload?.savedColumns;
            state.message = action?.payload?.message;
            state.isLoading = false;
        },
        createTableColumnSubFormModuleFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        updateTableColumnSubFormModuleStart: (state) => {
            state.isLoading = true;
        },
        updateTableColumnSubFormModuleSuccess: (state, action) => {
            state.tableColumns = action?.payload?.updateColumns;
            state.message = action?.payload?.message;
            state.isLoading = false;
        },
        updateTableColumnSubFormModuleFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getSubFormModuleCreatedRecordsStart: (state) => {
            state.isLoading = true;
        },
        getSubFormModuleCreatedRecordsSuccess: (state, action) => {
            let payload = action?.payload;
            state.createdRecords = {
                todayCount : payload?.todayCount,
                oneWeekCount : payload?.oneWeekCount,
                oneMonthCount : payload?.oneMonthCount
            };
            state.message = payload?.message;
            state.isLoading = false;
            state.status = payload?.status;
            state.reload = false;
            state.exit = false;
        },
        getSubFormModuleCreatedRecordsFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        getSubFormModuleGraphicalStatusStart: (state) => {
            state.isLoading = true;
        },
        getSubFormModuleGraphicalStatusSuccess: (state, action) => {
            let payload = action?.payload;
            state.graphicalStatus = {
                InApprovalCount : payload?.InApprovalCount,
                SuccessCount : payload?.SuccessCount,
                FailCount : payload?.FailCount
            };
            state.message = payload?.message;
            state.isLoading = false;
            state.status = payload?.status;
            state.reload = false;
            state.exit = false;
        },
        getSubFormModuleGraphicalStatusFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        subFormModuleLogStart: (state) => {
            state.isLoading = true;
        },
        subFormModuleLogSuccess: (state, action) => {
            state.moduleLogs = action?.payload?.module_logs;
            state.moduleMessage = action?.payload?.message;
            state.isLoading = false;
            state.exit = true;
        },
        subFormModuleLogFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        resetStateModule: (state) => {
            state.formsubmodules = [];
            state.modules = [];
        },
        destroyModuleLog: (state) => {
            state.moduleLogs = [];
            state.moduleMessage = null;
        }
    }
});

export const {
    createSubFormStart,
    createSubFormSuccess,
    createSubFormFailure,
    getSubFormListStart,
    getSubFormListSuccess,
    getSubFormListFailure,
    getSubFormListByIdStart,
    getSubFormListByIdSuccess,
    getSubFormListByIdFailure,
    updateSubFormByIdStart,
    updateSubFormByIdSuccess,
    updateSubFormByIdFailure,
    removeSubFormByIdStart,
    removeSubFormByIdSuccess,
    removeSubFormByIdFailure,
    bulkUploadSubFormByIdStart,
    bulkUploadSubFormByIdSuccess,
    bulkUploadSubFormByIdFailure,
    createTableColumnSubFormModuleStart,
    createTableColumnSubFormModuleSuccess,
    createTableColumnSubFormModuleFailure,
    updateTableColumnSubFormModuleStart,
    updateTableColumnSubFormModuleSuccess,
    updateTableColumnSubFormModuleFailure,
    getSubFormModuleCreatedRecordsStart,
    getSubFormModuleCreatedRecordsSuccess,
    getSubFormModuleCreatedRecordsFailure,
    getSubFormModuleGraphicalStatusStart,
    getSubFormModuleGraphicalStatusSuccess,
    getSubFormModuleGraphicalStatusFailure,
    subFormModuleLogStart,
    subFormModuleLogSuccess,
    subFormModuleLogFailure,
    resetStateModule,
    destroyModuleLog
} = subFormSlice?.actions;

export default subFormSlice?.reducer;